import { API } from "constants/api";
import { IAIHealthResponse, IChatAnswerParams } from "./aiAssistant.types";
import axios, { AxiosResponse } from "axios";
import qs from "qs";

export const getBalanceChartHealth = (): Promise<AxiosResponse<IAIHealthResponse>> =>
    axios.get(API.AI_ASSISTANT.BALANCE_CHART_HEALTH);

export const getBalanceChartAssistantAnswer = async ({
    payload,
    queryStrings,
    onAnswerChunk,
    signal,
}: IChatAnswerParams): Promise<void> => {
    const response = await fetch(
        `${process.env.REACT_APP_URL_API}${API.AI_ASSISTANT.BALANCE_CHART_PROMPT}?${qs.stringify(queryStrings, {
            arrayFormat: "repeat",
        })}`,
        {
            method: "POST",
            signal: signal,
            headers: {
                "Content-Type": "application/json",
                Accept: "text/event-stream",
            },
            credentials: "include",
            body: JSON.stringify(payload),
        }
    );

    if (!response.ok) {
        let errorMessage = `Assistant responded with status: ${response.status} ${response.statusText}`;

        try {
            const errorData = await response.json();
            if (errorData?.message) {
                errorMessage = errorData.message;
            }
        } catch (error) {
            console.warn("Failed to parse assistant error response as JSON:", error);
        }

        throw new Error(errorMessage);
    }

    if (!response.body) {
        throw new Error("Assistant response body is empty.");
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();

    let buffer = "";

    while (true) {
        const { done, value } = await reader.read();

        if (done) break;

        // Keep unfinished content in a buffer as chunks can arrive incomplete in the event stream.
        buffer += decoder.decode(value, { stream: true });
        const rawEvents = buffer.split("\n\n");
        buffer = rawEvents.pop() || "";

        for (const rawEvent of rawEvents) {
            try {
                const eventLines = rawEvent.split("\n");
                const eventLine = eventLines.find((line) => line.startsWith("event:"));
                const dataLine = eventLines.find((line) => line.startsWith("data:"));

                // Ignore incomplete or malformed blocks and move on with next iteration.
                if (!eventLine || !dataLine) {
                    continue;
                }

                const eventType = eventLine.replace("event:", "").trim();
                const data = dataLine.replace("data:", "").trim();

                // If event is not ANSWER or data is empty,move on with next iteration.
                if (eventType !== "ANSWER" || !data) {
                    continue;
                }

                const answerChunk = JSON.parse(data);
                onAnswerChunk(answerChunk);
            } catch (error) {
                console.error("Error processing response chunk:", error);
            }
        }
    }
};
